module.exports = __webpack_public_path__ + "static/grafid_logo-2fb6adbb76897b4e7376a64f2c3c2fde.png";